import styled from 'styled-components'

export const AboutContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 700px;
  background-image: url('/images/aboutus/banner-nosotros.jpg');
  background-size: cover;
  background-position: center;
  padding: 0 5%;

  @media (max-width: 720px) {
    flex-direction: column;
    justify-content: flex-start;
    background-image: url('/images/aboutus/banner-nosotros-mobile.jpg');
    padding: 20px;
  }
`

export const TextContainer = styled.div`
  max-width: 40%;
  color: white;
  padding: 20px;
  border-radius: 10px;

  h1 {
    font-family: Poppins;
    font-size: 40px;
  }

  p {
    font-family: Poppins;
    font-size: 20px;
  }

  @media (max-width: 720px) {
    max-width: 100%;
    text-align: center;
    margin-bottom: 20px;

    h1 {
      font-size: 30px;
    }

    p {
      font-size: 14px;
    }
  }
`
